export interface EngagementRatingConfig {
  value: number;
  label: string;
  description: string;
  color: string;
}

// MED-979: labels updated to title case per AC3. Values unchanged — storage
// remains the integer 1–5 in participant_engagement_ratings.rating.
export const ENGAGEMENT_RATING_CONFIG: EngagementRatingConfig[] = [
  {
    value: 1,
    label: 'Very Disengaged',
    description: 'Cameras off, limited responses to prompts, distracted',
    color: 'red',
  },
  {
    value: 2,
    label: 'Below Average Engagement',
    description: 'Below average engagement',
    color: 'orange',
  },
  {
    value: 3,
    label: 'Average',
    description: 'Listening / following but not participating at a high level',
    color: 'yellow',
  },
  {
    value: 4,
    label: 'Above Average Engagement',
    description: 'Above average engagement',
    color: 'teal',
  },
  {
    value: 5,
    label: 'Very Engaged',
    description: 'Camera on, off mute, actively listening, asking follow-up questions',
    color: 'green',
  },
];

export const ENGAGEMENT_RATING_MAP = new Map(
  ENGAGEMENT_RATING_CONFIG.map((r) => [r.value, r]),
);
